type VideoRecord = {
    title: string;
    description: string;
    url: string;
};

export const videos: ReadonlyArray<VideoRecord> = [
    {
        title: 'Full MosaicONE Overview',
        description: 'Learn how to navigate MosaicONE menus, build a theme, schedule and more.',
        url: 'https://player.vimeo.com/video/911697317',
    },
    {
        title: 'Introduction to MosaicONE',
        description: "An overview of MosaicONE's features and capabilities for anyone new to the system",
        url: 'https://player.vimeo.com/video/518781657',
    },
    {
        title: 'Navigating the Theme Editor',
        description: 'A detailed overview of the MosaicONE Theme Editor menus and interface. Create custom themes from scratch for your digital display using text, images, video, time/weather widgets, news, stocks, and HTML.',
        url: 'https://player.vimeo.com/video/525751513',
    },
    {
        title: 'Creating a Theme From Scratch',
        description: 'A step-by-step walk through of creating a theme using the various widgets MosaicONE has to offer',
        url: 'https://player.vimeo.com/video/531450342',
    },
    {
        title: 'Setting Up a Position Indicator Theme',
        description: 'Review the steps needed to set up a theme with a position indicator.',
        url: 'https://player.vimeo.com/video/536985073',
    },
    {
        title: 'Save, Publish, and Preview Themes',
        description: 'Learn how to save and publish your theme to your elevator screens, as well as preview your theme live on your web browser.',
        url: 'https://player.vimeo.com/video/537859598',
    },
    {
        title: 'Duplicating & Scheduling Themes',
        description: 'This video will cover advanced options to manage your theme and screens: copying a theme to the same building or another building to create versions of your theme for special events or seasons; sharing a theme to manage one theme across multiple buildings; and scheduling themes ahead of time to automatically play at the desired time',
        url: 'https://player.vimeo.com/video/542221289',
    },
    {
        title: 'Device Status & Event Logs',
        description: 'View the status and details of your device, export a CVS log of status updates, and find your device type.',
        url: 'https://player.vimeo.com/video/546519093',
    },
];
